// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1cf-D","tab":"_3Yd1J","shift":"_1i1AI","active":"_1yxGy"};